<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-0 lg:py-0 px-6 flex align-items-center justify-content-between lg:static">
            <div class="flex align-items-center">
                <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple"
                   v-styleclass="{ selector: '#navbar-8', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-bars text-4xl"></i>
                </a>
            </div>
        </div>
        <div id="navbar-8"
             class="py-0 hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 surface-border">
            <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                <li>
                    <a @click="processBasic" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Basic</span>
                    </a>
                </li>
                <li>
                    <a @click="processUpgrade" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Upgrade or Downgrade</span>
                    </a>
                </li>
                <li>
                    <a @click="processPasswordChange" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Change Password</span>
                    </a>
                </li>
                <li>
                    <a @click="processAlerts" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Alerts</span>
                    </a>
                </li>
                <li>
                    <a @click="processEmailLists" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Email Lists</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>


<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[MenuConfiguration][mounted] System is active.");
                console.log("[MenuConfiguration][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[MenuConfiguration][mounted] System is NOT active.");
                console.log("[MenuConfiguration][mounted] Error = ", e);

                this.userStore.clearUser;
                this.$router.push("login");
            });

        if (this.userStore.user === undefined) {
            console.log("[MenuConfiguration][mounted] User is NOT defined.");

            this.userStore.clearUser;
            this.$router.push('login');
        } else {
            console.log("[MenuConfiguration][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            UserService.getUser(this.userStore.user.id)
                .then(data => {
                    this.profile = data.data;
                    console.log("[MenuConfiguration][mounted] Data = ", data);

                })
                .catch(e => {
                    console.log("[MenuConfiguration][mounted] No user data found.");
                    console.log("[MenuConfiguration][mounted] Error = ", e);

                    this.userStore.clearUser;
                    this.$router.push('login');
                });
        }
    },
    data() {
        return {
            profile: {},
        }
    },
    methods: {
        processBasic() {
            // console.log("[MenuConfiguration][processBasic] Beginning.");
            window.location.href = "/#/siConfiguration";
        },
        processUpgrade() {
            // console.log("[MenuConfiguration][processBasic] Beginning.");
            window.location.href = "/#/siConfigurationUpgrade";
        },
        processPasswordChange() {
            // console.log("[MenuConfiguration][processBasic] Beginning.");
            window.location.href = "/#/siConfigurationPassword";
        },
        processAlerts() {
            // console.log("[MenuConfiguration][processAlerts] Beginning.");
            window.location.href = "/#/siConfigurationAlerts";
        },
        processEmailLists() {
            // console.log("[MenuConfiguration][processEmailLists] Beginning.");
            window.location.href = "/#/siConfigurationEmailLists";
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
